import { render, staticRenderFns } from "./MiddleCategory.vue?vue&type=template&id=522ba010&scoped=true&"
import script from "./MiddleCategory.vue?vue&type=script&lang=js&"
export * from "./MiddleCategory.vue?vue&type=script&lang=js&"
import style0 from "./MiddleCategory.vue?vue&type=style&index=0&id=522ba010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ba010",
  null
  
)

export default component.exports